import { useForm } from "react-hook-form";
import { useRecoilState } from "recoil";
import { writingDetailInfoAtom } from "./Atom/writingDetailInfoAtom";
import { formFlowAtom } from "./Atom/formFlowAtom";
import { useState } from "react";
import axios from "axios";

interface SelectMainThemeType {
  mainTheme: string;
  customTheme: string;
}

const SelectMainThemeForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
  } = useForm<SelectMainThemeType>({
    defaultValues: {
      mainTheme: "",
      customTheme: "",
    },
  });

  const [detailInfo, setDetailInfo] = useRecoilState(writingDetailInfoAtom);
  const [flow, setFlow] = useRecoilState(formFlowAtom);
  const [isCustom, setIsCustom] = useState(false); // 직접 입력 상태 관리

  const dummyThemeList = ["마법", "모험", "탐험", "공룡", "기사"];

  const API_ENDPOINT = "https://your-api-endpoint.com";

  const sendInfoToGetQuestions = async (
    genre: string,
    detailedGenre: string,
    age: number,
    mainTheme: string
  ) => {
    try {
      const data = {
        genre,
        detailedGenre,
        age,
        mainTheme,
      };

      const response = await axios.post(`${API_ENDPOINT}`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error sending genre age info mainTheme:", error);
      throw error;
    }
  };

  const onValid = async (data: SelectMainThemeType) => {
    const finalTheme = isCustom ? data.customTheme : data.mainTheme;
    if (finalTheme) {
      console.log("Selected mainTheme:", finalTheme);
      //   const questions = await sendInfoToGetQuestions(
      //     detailInfo.genre,
      //     detailInfo.detailedGenre,
      //     detailInfo.age,
      //     finalTheme
      //   )
      setDetailInfo((prev) => ({
        ...prev,
        mainTheme: finalTheme,
        // questions,
      }));

      setFlow(5);
    }
  };

  const onInvalid = (errors: any) => {
    console.log("Errors:", errors);
  };

  const selectedTheme = watch("mainTheme");

  // 직접 입력 상태를 업데이트
  const handleMainThemeChange = (value: string) => {
    setValue("mainTheme", value); // mainTheme 값 업데이트
    setIsCustom(value === "custom"); // custom 선택 여부
  };

  return (
    <div>
      <div className="text-xl font-bold mb-4">주요주제를 선택하세요</div>
      <form onSubmit={handleSubmit(onValid, onInvalid)}>
        <div className="mb-4">
          <label
            htmlFor="mainTheme"
            className="block text-gray-500 font-medium"
          >
            주요주제선택
          </label>
          <select
            id="mainTheme"
            {...register("mainTheme", { required: "주제를 선택해주세요!" })}
            className="block w-full mt-2 p-2 border border-gray-300 dark:bg-slate-600 rounded-lg"
            onChange={(e) => handleMainThemeChange(e.target.value)}
          >
            <option value="">-- 주제를 선택하세요 --</option>
            {dummyThemeList.map((theme, index) => (
              <option key={index} value={theme}>
                {theme}
              </option>
            ))}
            <option value="custom">직접 입력</option>
          </select>
          {errors.mainTheme && (
            <p className="text-red-500 mt-2">{errors.mainTheme.message}</p>
          )}
        </div>

        {/* 직접 입력 필드 */}
        {isCustom && (
          <div className="mb-4">
            <label
              htmlFor="customTheme"
              className="block text-gray-500 font-medium"
            >
              직접 주제 입력 (10자 이내)
            </label>
            <input
              id="customTheme"
              type="text"
              {...register("customTheme", {
                required: "주제를 입력해주세요!",
                maxLength: {
                  value: 10,
                  message: "주제는 10자 이내로 작성해주세요.",
                },
              })}
              className="block w-full mt-2 p-2 border border-gray-300 dark:bg-slate-600 rounded-lg"
            />
            {errors.customTheme && (
              <p className="text-red-500 mt-2">{errors.customTheme.message}</p>
            )}
          </div>
        )}

        <button
          type="submit"
          className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
        >
          다음
        </button>
      </form>
    </div>
  );
};

export default SelectMainThemeForm;
